import { COORDS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppNoApiAction, AppAction, BaseAsyncReducerState } from "../../types";

export interface CoordsResponse extends BaseAsyncReducerState {
    results: Record<string, unknown>;
}

// Define an initial state value for the app
const initialState: CoordsResponse  = {
    loading: false,
    error: false,
    results: {}
}


function CoordsReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case COORDS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case COORDS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case COORDS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case COORDS.RESET:
            return {
                ...state,
                loading: false,
                error: payload,
                results: {}
            };
        default:
            return state
        }
}

export default CoordsReducer;